"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureFieldLogic = void 0;
var signature_fieldtype_1 = require("./signature.fieldtype");
Object.defineProperty(exports, "SignatureFieldLogic", { enumerable: true, get: function () { return signature_fieldtype_1.SignatureFieldLogic; } });
